"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceMetadata = {
    apiVersion: "2006-03-01",
    endpointPrefix: "s3",
    protocol: "rest-xml",
    serviceAbbreviation: "Amazon S3",
    serviceFullName: "Amazon Simple Storage Service",
    serviceId: "S3",
    signatureVersion: "s3",
    uid: "s3-2006-03-01"
};
exports.clientVersion = "0.1.0-preview.1";
//# sourceMappingURL=ServiceMetadata.js.map